import React, { FC, ElementType, MouseEvent } from 'react';

// components
import AampeTooltip from '../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

interface IconButtonProps {
    Icon: ElementType;
    tooltip?: string;
    action: (event: MouseEvent<HTMLDivElement>) => void;
    isDisabled?: boolean;
    size?: string;
}

interface IconProps {
    isDisabled: boolean;
    size: string;
}

const IconEditorMenuButton: FC<React.PropsWithChildren<IconButtonProps>> = ({
    Icon,
    tooltip = '',
    action,
    isDisabled = false,
    size = '20px',
}) => {
    const handleClick = !isDisabled ? action : () => {};

    return (
        <div style={{ height: 'fit-content' }} onClick={handleClick}>
            <AampeTooltip title={tooltip}>
                <IconWrapper size={size} isDisabled={isDisabled}>
                    <Icon />
                </IconWrapper>
            </AampeTooltip>
        </div>
    );
};

export default React.memo(IconEditorMenuButton);
const IconWrapper = styled.span.withConfig({
    shouldForwardProp: (prop) => !['isDisabled', 'size'].includes(prop),
})<IconProps>(({ isDisabled, size }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    height: 'fit-content',
    padding: 0,
    margin: 0,
    cursor: 'pointer',

    '& svg': {
        color: isDisabled
            ? aampeTheme.colors.backgroundWG01
            : aampeTheme.colors.gray600,
        width: size,
        height: size,
    },

    '&:hover svg': {
        color: isDisabled
            ? aampeTheme.colors.backgroundWG01
            : aampeTheme.colors.solidA01,
    },
}));
